import httpClient from '../httpClient.js';

const statusHandler = {
  async getAlerts () {
    try {
      const response = await httpClient({
        method: 'get',
        url: '/api/systemStatus',
        options: {
          withCredentials: true
        }
      });
      if (response.status !== 200) {
        return false;
        // throw new Error(`Server responded with status ${response.status}.`);
      }
      return response.data;
    } catch (err) {
      return false;
    }
  },
  async getSystemStatus () {
    try {
      const response = await httpClient({
        method: 'get',
        url: '/api/status/systems',
        options: {
          withCredentials: true
        }
      });
      if (response.status !== 200) {
        return false;
        // throw new Error(`Server responded with status ${response.status}.`);
      }
      return response.data.Systems;
    } catch (err) {
      return false;
    }
  }
};

export {
  statusHandler
};
